import { useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Avatar, Box, Divider, Typography, Stack, MenuItem, IconButton, Popover } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// hooks
import useAuth from '../../../hooks/useAuth';

export default function AccountPopover() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const MENU_OPTIONS = [
    {
      label: 'Home',
      icon: 'eva:home-fill',
      onClick: () => {
        const linkToNavigate = `/dashboard/app`;
        // move to the session page for the id
        navigate(linkToNavigate);
      },
    },
    {
      label: 'Settings',
      icon: 'eva:settings-2-fill',
      onClick: () => {
        const linkToNavigate = `/dashboard/account`;
        // move to the session page for the id
        navigate(linkToNavigate);
      },
    },
  ];

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleLogout = () => {
    logout();
  };

  if (!user) {
    return null;
  }

  const handleClose = () => {
    setOpen(null);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        aria-label="Account"
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        {/* The button used to have no children at all — a 0x0 invisible
            control, which is how the account menu (and with it the only way to
            log out) became unreachable. */}
        <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main', fontSize: 14 }}>
          {(user.username || '?').charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user.displayName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={option.onClick}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </Popover>
    </>
  );
}
